import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'contractApproval' })

export class ContractApprovalPipe implements PipeTransform {
    transform(data: any) {
        if (data == null || data === '') return '';
        if (data === true) return 'Approved';
        if (data === false) return 'Denied';
    
        return data;
    }
}